import React, { useContext, useEffect, useState } from "react";
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import DownloadExcel from "src/reusables/DownloadExcel";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import formatter from "src/reusables/formatter";
import { getAll } from "src/services/Users";
import { Toaster } from "src/components/Toaster";
import ls from "local-storage";
import Authentication, { AUTH_KEY } from "src/utils/auth/Authentication";
import { AuthContext } from "src/App";
function Users() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.users &&
      res.users.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.name,
          alias: item.alias,
          phone: item.phone,
          email: item.email,
          backofficeAccess: item.backoffice_access === 1 ? "Ya" : "Tidak",
          rawBackofficeAccess: item.backoffice_access,
          spvName: item.supervisor_name,
          spvId: item.supervisor_id,
        };
      });

    setDataRows(rows);

    const columns = [
      { field: "no", headerName: "No", width: "50" },
      { field: "name", headerName: "Nama", flex: 1 },
      { field: "alias", headerName: "Alias", flex: 1 },
      { field: "phone", headerName: "HP", flex: 1 },
      { field: "email", headerName: "Email", flex: 1 },
      { field: "spvName", headerName: "Supervisor", flex: 1 },
      { field: "backofficeAccess", headerName: "Akses Backoffice", flex: 1 },
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate("/user-actions", { state: params.row });
  }

  return (
    <div style={{ color: "black" }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? "red"} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Users </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: "right" }}>
              <CButton
                style={{ borderColor: "primary" }}
                onClick={() => {
                  navigate("/user-actions");
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel rows={dataRows} columns={dataColumns} excelName="Daftar Users" config={{ width: "20" }} />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: "16px" }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: "center" }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Users;
